import React, { useState, useEffect } from "react";
import "./OrderTracking.css";
import API_URL from "../apiConfig";

const API_BASE_URL = API_URL;

const OrderTracking = ({ orderId, onBack }) => {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (orderId) fetchOrderDetail();
  }, [orderId]);

  const fetchOrderDetail = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      setOrder(data);
    } catch (err) {
      console.error("Fetch order detail error:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="tracking-loading container">
        <h2>Tracking your order...</h2>
      </div>
    );
  if (!order)
    return (
      <div className="container">
        <h2>Order not found</h2>
        <button onClick={onBack}>Go Back</button>
      </div>
    );

  const steps = ["Ordered", "Packed", "Shipped", "Delivered"];
  const currentStepIndex = steps.indexOf(order.status);

  return (
    <div className="tracking-page container">
      <div className="tracking-header">
        <button className="back-link" onClick={onBack}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Orders
        </button>
        <h1>Track Order #{order._id.slice(-8).toUpperCase()}</h1>
      </div>

      <div className="tracking-layout">
        {/* Progress Tracker */}
        <div className="tracker-box card">
          <div className="tracker-steps">
            {steps.map((step, index) => (
              <div
                key={step}
                className={`step ${index <= currentStepIndex ? "completed" : ""}`}
              >
                <div className="step-circle">
                  {index < currentStepIndex
                    ? "✓"
                    : index === currentStepIndex
                      ? "●"
                      : index + 1}
                </div>
                <div className="step-label">{step}</div>
                {index < steps.length - 1 && <div className="step-line"></div>}
              </div>
            ))}
          </div>

          <div className="delivery-est">
            {order.status === "Delivered"
              ? `Delivered on ${new Date(order.deliveredAt).toLocaleDateString()}`
              : `Estimated Delivery: By ${new Date(new Date(order.createdAt).getTime() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString()}`}
          </div>
        </div>

        {/* Order Details */}
        <div className="order-details-grid">
          <div className="items-box card">
            <h3>Shipment Details</h3>
            <div className="tracking-items">
              {order.orderItems.map((item, idx) => (
                <div key={idx} className="tracking-item">
                  <img
                    src={
                      item.image.startsWith("http")
                        ? item.image
                        : `${API_BASE_URL}${item.image}`
                    }
                    alt=""
                  />
                  <div className="t-item-info">
                    <p className="t-name">{item.name}</p>
                    <p className="t-meta">
                      Size: {item.size} | Qty: {item.quantity}
                    </p>
                    <p className="t-price">₹{item.price}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="shipping-box card">
            <h3>Delivery Address</h3>
            <p className="customer-name">{order.user.fullName}</p>
            <p className="address-text">
              123 Myntra Street, Near Fashion Square,
              <br />
              Bangalore, Karnataka - 560001
            </p>
            <p className="phone-text">Mobile: +91 9876543210</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderTracking;
